module.exports = __webpack_public_path__ + "img/24-white.08e1f40f.svg";